export const getIncidentId = (errorString = '') => {
  if (!errorString || typeof errorString !== 'string') return errorString;

  const incidentId = errorString.match(/IncidentId: \d+/i);

  if (!incidentId) return errorString;
  return incidentId[0];
};
